import { render, staticRenderFns } from "./RepeaterColor.vue?vue&type=template&id=587d166e&"
import script from "./RepeaterColor.vue?vue&type=script&lang=js&"
export * from "./RepeaterColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports